import React from "react";
import { CLASS_BOOKING } from "../../../assets/asset";

const PageContainer = ({ children, className = "" }) => {
  return (
    <div
      className={`flex flex-col font-sans relative min-h-screen w-full overflow-x-hidden bg-blue-50 ${className}`}
      style={{
        backgroundImage: `url(${CLASS_BOOKING.bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        WebkitBackgroundAttachment: "fixed",
      }}
    >
      {children}
    </div>
  );
};

export default PageContainer;